<template>
  <section class="product-card" @click="showDetail()">
    <section class="header">
      <is-in-cart :item="product" class="cart-indicator"></is-in-cart>
      <!--  <slot name="header" v-if="isOwnPrintStore(product.printStoreId)">
        <authorization-component print-store-role="ADMIN" class="kebab">
          <popup-menu anchor-position="top-right">
            <button class="kebab-btn" slot="trigger"><span></span></button>
            <menu-item @click="edit()">Wijzigen</menu-item>
            <menu-item @click="remove()">Verwijderen</menu-item>
            <menu-item @click="download()">Downloaden</menu-item>
          </popup-menu>
        </authorization-component>
      </slot> -->
    </section>
    <retry-image
      :url="productImage(value, value.printSpecification, 282, (color = ''))"
      :timestamp="product.previewTimestamp"
      :bordered="hasBorder"
      class="card-image"
      :alt="product.name"
    ></retry-image>
    <card-text
      :name="product.name"
      :price="price"
      :type="$filters.capitalize(product.printSpecification.title)"
      :colors="colors"
    ></card-text>
  </section>
</template>

<script>
import CardText from '@/features/printstore/children/CardText.vue'
import PrintStoreMixin from '@/features/printstore/PrintStoreMixin.js'
import ProductSettings from '@/features/printstore/children/ProductSettings.vue'
import IsInCart from '@/features/printstore/children/IsInCart.vue'
import RetryImage from '@/components/ui/RetryImage.vue'
import { mapStores } from 'pinia'
import { usePriceTableStore } from '@/features/printstore/PriceTable.store'
import { usePrintStoreStore } from '@/features/printstore/PrintStore.store'

export default {
  name: 'ProductCard',
  components: {
    IsInCart,
    CardText,
    RetryImage
  },
  props: {
    value: {}
  },
  mixins: [PrintStoreMixin],
  data() {
    return {
      product: this.value,
      price: ''
    }
  },
  computed: {
    ...mapStores(usePriceTableStore, usePrintStoreStore),
    hasBorder() {
      return !!(
        this.product.displaySpecification &&
        this.product.displaySpecification.border
      )
    },
    colors() {
      if (this.product.hasCustomizableColours) {
        return {
          blauw: {
            color: '#038bd3',
            name: 'Blauw'
          },
          geel: {
            color: '#fbd101',
            name: 'Geel'
          },
          groen: {
            color: '#009640',
            name: 'Groen'
          },
          rood: {
            color: '#E30528',
            name: 'Rood'
          },
          wit: {
            color: '#fff',
            name: 'Wit'
          },
          zwart: {
            color: '#000000',
            name: 'Zwart'
          }
        }
      } else if (this.value.printSpecification.colors) {
        return this.value.printSpecification.colors.values
      } else {
        return undefined
      }
      /*  return this.value.printSpecification.colors
        ? this.value.printSpecification.colors.values
        : undefined */
    }
  },
  watch: {
    value(val) {
      this.product = val
    }
  },
  mounted() {
    // See if we need to popup
    if (this.$route.params.productId === this.product.id) {
      this.showDetail()
    }

    // get the cheapest price
    let product = Object.keys(this.value.printSpecification.products.values)[0] // get first product from products = cheapest
    let spec = ''
    if (this.value.printSpecification.specs) {
      this.value.printSpecification.specs.forEach((s) => {
        // get first spec from each spec = cheapest

        spec += Object.keys(s.values)[0]
      })
      product = product + spec
    }
    if (this.hidePrice) {
      this.price = ''
    } else if (
      this.hideOwnPrice &&
      this.value.printStoreId != this.printStoreStore.defaultPrintStoreId
    ) {
      this.price = ''
    } else if (this.priceTableStore.priceTable.hasOwnProperty(product)) {
      let price = this.priceTableStore.priceTable[product].toFixed(2) || ''
      this.price = '€ ' + price.replace('.', ',')
    }
  },
  methods: {
    edit() {
      this.$modal.show(
        ProductSettings,
        {
          product: this.product,
          callback: async (product) => {
            this.product = product
          }
        },
        { height: 530, width: 832, adaptive: true, classes: 'transparent' }
      )
    },
    remove() {
      this.deleteProduct(this.product).then(() =>
        this.$emit('removed', this.product.id)
      )
    },
    async showDetail() {
      this.$router.push({
        name: 'printStoreProduct',
        params: {
          categoryId:
            this.$route.params.categoryId ||
            this.product.collections[0].categoryId ||
            this.product.categoryIds[0],
          collectionId:
            this.$route.params.collectionId ||
            this.product.collections[0].collectionId,
          productId: this.product.id
        }
      })
    },
    download() {
      window.location = `/api/v3/print-store/${this.rootStore.user.printStore.id}/download/${this.product.image}/${this.product.name}`
    }
  }
}
</script>

<style lang="scss" scoped></style>
